import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import CheckableBoxExample from '../examples/CheckableBox';
const CheckableBoxExampleSource = require('!!raw-loader!../examples/CheckableBox');
const CheckableBoxPage = () => (<div>
        <Helmet title="CheckableBox"/>
        <h3>CheckableBox</h3>
        <div className="docs-example">
            <CheckableBoxExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{CheckableBoxExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`type Props = {|
    className: string,
    onClick: Function,
    children: Node,
    checked: boolean,
    block: boolean,
    checkboxPosition: 'right-top' | 'right-middle',
|};

CheckableBox.defaultProps = {
    className: '',
    checked: false,
    block: false,
    onClick: () => undefined,
    checkboxPosition: 'right-top',
};
`}
                </PrismCode>
            </pre>
        </div>
    </div>);
export default CheckableBoxPage;
